shadow$provide[371] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 getSample(vec4 xyzw);

float floatStretch(vec4 xyzw, float channelIndex) {
  vec4 sample = getSample(xyzw);
  vec2 xy = channelIndex > 1.5 ? sample.zw : sample.xy;
  return mod(channelIndex, 2.0) > .5 ? xy.y : xy.x;
}`;

};